import { render, staticRenderFns } from "./EdiStatusIcon.vue?vue&type=template&id=28e6d8e9&scoped=true&"
import script from "./EdiStatusIcon.vue?vue&type=script&lang=js&"
export * from "./EdiStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./EdiStatusIcon.vue?vue&type=style&index=0&id=28e6d8e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6d8e9",
  null
  
)

/* custom blocks */
import block0 from "./EdiStatusIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports